import { FormItem, FormLabel } from './formBuilder.types';

type FormBuilderKeyItem<T> = FormItem<T> | FormLabel | null | undefined;

/**
 * Returns a stable React key for a FormBuilder config item so conditional fields
 * do not remount unrelated inputs when sibling items are inserted or removed.
 * @param item - Form config entry (input, label, group, passthrough, or array group).
 * @param index - Position in the parent config array (disambiguates labels and passthrough).
 * @returns Stable string key for React list rendering.
 */
export function getFormBuilderItemKey<T>(
  item: FormBuilderKeyItem<T>,
  index: number
): string {
  if (!item) {
    return `empty:${index}`;
  }

  if (Array.isArray(item)) {
    return `group:${item
      .map((child, childIndex) => getFormBuilderItemKey(child, childIndex))
      .join('|')}`;
  }

  switch (item.type) {
    case 'input':
      return `input:${String(item.name)}`;
    case 'label':
      return `label:${index}:${item.label}`;
    case 'group':
      return `group:${item.items
        .map((child, childIndex) => getFormBuilderItemKey(child, childIndex))
        .join('|')}`;
    case 'passthrough':
      return `passthrough:${index}`;
    default:
      return `unknown:${index}`;
  }
}
